<div class="detailcontainer">
<mat-toolbar color="secondary">
  <ldw-document-title [document]="document"></ldw-document-title>
  <span class="spacer"></span>
  <div class="buttons">
    <button mat-icon-button (click)="close()" matTooltip="{{ showToolTip()? ('DIALOGS.CLOSE' | translate):'' }}">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>
  <div class="detailcontent" >
    <table mat-table [dataSource]="history" class="mat-elevation-z8">
      <ng-container matColumnDef="archived">
        <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.ARCHIVED'|translate}}</th>
        <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)"> {{element.archived}} </a> </td>
      </ng-container>

      <ng-container matColumnDef="changed">
        <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.CHANGEDATE'|translate}}</th>
        <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)"> {{element.changed}}</a> </td>
      </ng-container>

      <ng-container matColumnDef="changedBy">
        <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.CHANGEDBY'|translate}}</th>
        <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)"> {{element.changedBy}} </a> </td>
      </ng-container>

      <ng-container matColumnDef="job">
        <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.JOB'|translate}}</th>
        <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)"> {{element.job}} </a> </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row
          *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
